var fancybox = {
    init: function () {
        if ( $( "a.js-fancybox" ).length > 0 ) {
            $( "a.js-fancybox" ).attr( 'rel', 'gallery' ).fancybox();
        }
    }
}